export enum PopularTimezone {
  AMERICA_ANCHORAGE = 'America/Anchorage',
  AMERICA_CHICAGO = 'America/Chicago',
  AMERICA_DENVER = 'America/Denver',
  AMERICA_LOS_ANGELES = 'America/Los_Angeles',
  AMERICA_NEW_YORK = 'America/New_York',
  AMERICA_PHOENIX = 'America/Phoenix',
  AMERICA_TORONTO = 'America/Toronto',
  ASIA_DUBAI = 'Asia/Dubai',
  ASIA_HONG_KONG = 'Asia/Hong_Kong',
  ASIA_ISTANBUL = 'Asia/Istanbul',
  ASIA_SINGAPORE = 'Asia/Singapore',
  ASIA_TOKYO = 'Asia/Tokyo',
  ASIA_KOLKATA = 'Asia/Kolkata',
  EUROPE_BERLIN = 'Europe/Berlin',
  EUROPE_DUBLIN = 'Europe/Dublin',
  EUROPE_MADRID = 'Europe/Madrid',
  EUROPE_PARIS = 'Europe/Paris',
  GB = 'GB',
  HONKONG = 'Hongkong',
}
